module.exports = __webpack_public_path__ + "static/media/fv-logo-flat-icon-sm.2ac31526.png";